import { render, staticRenderFns } from "./UserLowerLevel.vue?vue&type=template&id=6ed52b62&scoped=true&"
import script from "./UserLowerLevel.vue?vue&type=script&lang=js&"
export * from "./UserLowerLevel.vue?vue&type=script&lang=js&"
import style0 from "./UserLowerLevel.vue?vue&type=style&index=0&id=6ed52b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed52b62",
  null
  
)

export default component.exports